<template>
  <app-card>
    <v-form v-model="formValidate">
      <v-container :class="{ 'pa-0': $vuetify.breakpoint.xsOnly }">
        <div class="pb-4">
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                v-model="form.organization01"
                @input="onInput(1)"
                :items="organizationDropdown01"
                :loading="loadingDropdown01"
                :disabled="organizationDropdown01.length <= 1"
                label="เลือกหน่วยงาน"
                hide-details="auto"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <v-row
            v-if="
              form.organization01 !== '' && organizationDropdown02.length > 0
            "
          >
            <v-col cols="12">
              <v-autocomplete
                v-model="form.organization02"
                @input="onInput(2)"
                :items="organizationDropdown02"
                :loading="loadingDropdown02"
                :disabled="organizationDropdown02.length <= 1"
                label="เลือกหน่วยงาน"
                hide-details="auto"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <v-row
            v-if="
              form.organization02 !== '' && organizationDropdown03.length > 0
            "
          >
            <v-col cols="12">
              <v-autocomplete
                v-model="form.organization03"
                @input="onInput(3)"
                :items="organizationDropdown03"
                :loading="loadingDropdown03"
                :disabled="organizationDropdown03.length <= 1"
                label="เลือกหน่วยงาน"
                hide-details="auto"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <v-row
            v-if="
              form.organization03 !== '' && organizationDropdown04.length > 0
            "
          >
            <v-col cols="12">
              <v-autocomplete
                v-model="form.organization04"
                :items="organizationDropdown04"
                :loading="loadingDropdown04"
                :disabled="organizationDropdown04.length <= 1"
                label="เลือกหน่วยงาน"
                hide-details="auto"
                outlined
                dense
              />
            </v-col>
          </v-row>
        </div>

        <v-row>
          <v-col cols="12" md="6">
            <v-select
              v-model="form.EmployeeTypeID"
              label="ประเภทบุคลากร"
              hide-details="auto"
              :items="empTypeDropdown"
              outlined
              dense
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6" :class="{ 'pb-1': $vuetify.MdAndDown }">
            <v-menu
              v-model="startDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-on="on"
                  :value="$dateFormatByLang(form.StartDate)"
                  label="ตั้งแต่วันที่"
                  hide-details="auto"
                  append-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  @click:append="startDateMenu = true"
                />
              </template>
              <v-date-picker
                v-model="form.StartDate"
                :locale="$lang === 'Tha' ? 'th' : 'en'"
                @input="startDateMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6" :class="{ 'pb-1': $vuetify.MdAndDown }">
            <v-menu
              v-model="finishDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-on="on"
                  :value="$dateFormatByLang(form.EndDate)"
                  label="ถึงวันที่"
                  hide-details="auto"
                  append-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  @click:append="finishDateMenu = true"
                />
              </template>
              <v-date-picker
                v-model="form.EndDate"
                :locale="$lang === 'Tha' ? 'th' : 'en'"
                :min="form.StartDate"
                @input="finishDateMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            รูปแบบรายงาน
            <v-radio-group
              v-model="form.ReportChoice"
              class="ma-0"
              row
              hide-details="auto"
            >
              <v-radio label="รายคน" value="emp" />
              <v-radio label="รายส่วนงาน" value="org" />
            </v-radio-group>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            การแสดงข้อมูล
            <v-radio-group
              v-model="form.FileType"
              class="ma-0"
              row
              hide-details="auto"
            >
              <v-radio label="Excel" value="excel" />
              <v-radio label="PDF" value="pdf" />
            </v-radio-group>
          </v-col>
        </v-row>

        <v-row align="center">
          <v-col cols="auto">
            <v-btn
              @click="onSearch"
              color="primary darken-2"
              :disabled="!canSearch"
              depressed
              large
            >
              แสดงข้อมูล
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <v-btn @click="onClear" color="secondary" depressed>
              ล้าง
            </v-btn>
          </v-col>
          <v-col></v-col>
        </v-row>
      </v-container>
    </v-form>
  </app-card>
</template>

<script>
export default {
  props: {
    page: {
      type: Number,
      default: 1,
    },
  },

  data() {
    return {
      formValidate: null,
      form: {
        ProgramItemMenuID: "mniRptEmpLeaveAll",
        organization01: "",
        organization02: "",
        organization03: "",
        organization04: "",
        EmployeeTypeID: "0",
        StartDate: "",
        EndDate: "",
        ReportChoice: "emp",
        FileType: "excel",
        store: "leave/reportLeaveMonthAll",
      },
      empTypeDropdown: [],
      organizationDropdown01: [],
      organizationDropdown02: [],
      organizationDropdown03: [],
      organizationDropdown04: [],
      loadingDropdown01: false,
      loadingDropdown02: false,
      loadingDropdown03: false,
      loadingDropdown04: false,
      startDateMenu: false,
      finishDateMenu: false,
    };
  },

  computed: {
    canSearch() {
      return (
        this.form.organization01 !== "" && this.form.organization01 !== "0"
      );
    },
  },

  watch: {
    $route() {
      this.setForm();
    },

    form: {
      handler(newVal) {
        for (let key in newVal) {
          if (newVal[key] === null || newVal[key] === undefined) {
            this.form[key] = "";
          }
        }
      },
      deep: true,
    },

    "form.StartDate": function(n) {
      if (this.form.StartDate >= this.form.EndDate) {
        this.form.EndDate = n;
      }
    },
  },

  async mounted() {
    const now = new Date();
    const nowMonth = now.getMonth() + 1;
    const nowYear = now.getFullYear();
    let startYear = "";
    let endYear = "";
    if (nowMonth <= 9) {
      startYear = nowYear - 1;
      endYear = nowYear;
    } else {
      startYear = nowYear;
      endYear = nowYear + 1;
    }
    this.form.StartDate = startYear + "-10-01";
    this.form.EndDate = endYear + "-09-30";

    await this.setOrganization(1);
    this.empTypeDropdown = await this.apiGetEmpType();
    await this.setForm();
  },

  methods: {
    async setForm() {
      this.form = { ...this.form, ...this.$route.query };
      if (
        this.$route.query.organization01 &&
        this.$route.query.organization01 != 0
      ) {
        this.organizationDropdown01 = await this.apiGetOrganizationDropdown();
        this.organizationDropdown02 = await this.apiGetOrganizationDropdown(
          this.$route.query.organization01
        );
      }

      if (
        this.$route.query.organization02 &&
        this.$route.query.organization02 != 0
      ) {
        this.organizationDropdown03 = await this.apiGetOrganizationDropdown(
          this.$route.query.organization02
        );
      }

      if (
        this.$route.query.organization03 &&
        this.$route.query.organization03 != 0
      ) {
        this.organizationDropdown04 = await this.apiGetOrganizationDropdown(
          this.$route.query.organization03
        );
      }
    },

    onSearch() {
      if (this.form.organization04 && this.form.organization04 !== "0") {
        this.form.OrganizationID = this.form.organization04;
      } else if (this.form.organization03 && this.form.organization03 !== "0") {
        this.form.OrganizationID = this.form.organization03;
      } else if (this.form.organization02 && this.form.organization02 !== "0") {
        this.form.OrganizationID = this.form.organization02;
      } else {
        this.form.OrganizationID = this.form.organization01;
      }

      this.$router.replace({ query: this.form }).catch(() => {
        console.log("same page, same result");
      });
      this.$emit("search", this.form);
    },

    async onClear() {
      const now = new Date();
      const nowMonth = now.getMonth() + 1;
      const nowYear = now.getFullYear();
      let startYear = "";
      let endYear = "";
      if (nowMonth <= 9) {
        startYear = nowYear - 1;
        endYear = nowYear;
      } else {
        startYear = nowYear;
        endYear = nowYear + 1;
      }
      const startDate = startYear + "-10-01";
      const endDate = endYear + "-09-30";

      this.form = {
        ProgramItemMenuID: "mniRptEmpLeaveAll",
        organization01: "",
        organization02: "",
        organization03: "",
        organization04: "",
        EmployeeTypeID: "0",
        StartDate: startDate,
        EndDate: endDate,
        ReportChoice: "emp",
        FileType: "excel",
        store: "leave/reportLeaveMonthAll",
      };

      await this.setOrganization(1);

      this.$router.push({ query: {} }).catch(() => {
        console.log("same page, same result");
      });
    },

    async onInput(index) {
      let max = 4;
      const parent = this.$zeroPrefix(index);

      if (this.form[`organization${parent}`]) {
        await this.setOrganization(
          index + 1,
          this.form[`organization${parent}`]
        );
      }

      for (max; max > index + 1; max--) {
        const i = this.$zeroPrefix(max);
        this.form[`organization${i}`] = "";
        if (
          max > index + 1 ||
          (max === index + 1 && !this.form[`organization${parent}`])
        )
          this[`organizationDropdown${i}`] = [];
      }
    },

    async setOrganization(index, parent) {
      const target = this.$zeroPrefix(index);
      this[`loadingDropdown${target}`] = true;
      const dropdown = await this.apiGetOrganizationDropdown(parent);
      this[`organizationDropdown${target}`] = dropdown;
      this[`loadingDropdown${target}`] = false;

      if (dropdown.length > 0) {
        this.form[`organization${target}`] = dropdown[0].value;
        await this.setOrganization(index + 1, dropdown[0].value);
      } else {
        this.form[`organization${target}`] = "";
      }
    },

    async apiGetOrganizationDropdown(parent) {
      let extendPath = "";
      if (parent) extendPath = "/" + parent + "/child";
      try {
        const res = await this.$store.dispatch(
          "employee/getLeaveCheckerOrgDropdown",
          extendPath
        );
        return res;
      } catch (e) {
        console.log(e.response || e);
        return [];
      }
    },

    async apiGetEmpType() {
      try {
        const res = await this.$store.dispatch("employee/getTypeDropdown");
        return res.map((item) => {
          return {
            text: item.text,
            value: item.value.toString(),
          };
        });
      } catch (e) {
        console.log(e.response || e);
        return [];
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
